import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from '..';
import { Routes } from '../../../navigation';
import { useTranslations } from '../../../hooks/translations';
import SeikoLogo from '../../../../../public/images/seiko-logo.svg';
import HoyaLogo from '../../../../../public/images/Hoya-LC.svg';
import HoyaLogoSmall from '../../../../../public/images/hoya-logo@2x.png';


import './styles.less';
import classNames from 'classnames';

export const HeaderLogo = ( props ) => {
    const { getString } = useTranslations();

    const imageSrc = useMemo( () => {
        if ( props.theme === 'seiko' ) {
            return SeikoLogo;
        } else {
            if ( props.small ) {
                return HoyaLogoSmall;
            } else {
                return HoyaLogo;
            }
        }
    }, [ props.theme, props.small ] );

    return (
        <Link push to={ Routes.Home.buildPath() }>
            <img
                tabIndex={ 0 }
                aria-label={ getString( 'application.title' ) }
                className={ classNames( 'header-logo', { small: props.small }, props.className ) }
                src={ imageSrc }
                alt=""
            >
            </img>
        </Link>
    );
};

HeaderLogo.defaultProps = {
    // ...
};

HeaderLogo.propTypes = {
    className: PropTypes.string,
};
